import {
    Card, CardContent, CardHeader, Grid,
    TextField, Button, Collapse, Link,
    Alert, Box, CardMedia, IconButton, Dialog, DialogContent, DialogActions, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
    Typography,
    InputLabel,
    OutlinedInput,
    InputAdornment
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import jwt_decode from "jwt-decode";
import { useDataContext } from '../contexts/dataContext';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function Login() {
    const { setEsAsistente, setEsJefe,
        usuario, setUsuario, setOpenAvisos } = useDataContext()
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword((showPassword) => !showPassword);
    //console.log(`Usuario en contexto ${JSON.stringify(usuario)}`)
    /*const [usuario, setUsuario] = useState({
        id: '',
        password: ''
    })*/

    const [openPerfiles, setOpenPerfiles] = useState(false)
    const [valueRadio, setValueRadio] = useState(null);

    const [loading, setLoading] = useState(false)
    const [perfiles, setPerfiles] = useState([])

    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');

    const navigate = useNavigate()

    const cargarUsuario = async (id) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${id}`)
        const data = await res.json()
        //console.log(`usuario logueado ${JSON.stringify(data)}`)
        setUsuario({ ...data })
    }


    const cargarPlan = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_GESTION_PORT}/planeacion/byUser/${usuario.id}/false/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        }

        )



        if (res.status === 404) {
            console.log('regresó 404 Plan actual no existe')
            // return { idPlanPresupuestal: 0, montoMaximo: 0 }
        }


        else {
            console.log('la planeación actual si existe')

            const data = await res.json()


            sessionStorage.setItem('idPlan', data.idPlanPresupuestal)
            sessionStorage.setItem('fasePlan', data.fase)

            const resPlanAnterior = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_GESTION_PORT}/planeacion/byUser/${usuario.id}/${Number(data.anio) - 1}/${sessionStorage.getItem('idEntidad')}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )

            if (resPlanAnterior === 404) {
                console.log('No existe el plan anterior')
            }
            else {
                console.log('El plan anterior existe')
                const datosPlanAnterior = await resPlanAnterior.json()
                sessionStorage.setItem('idPlanAnterior', datosPlanAnterior.idPlanPresupuestal)
                console.log(`idPlanAnterior ${datosPlanAnterior.idPlanPresupuestal}`)
            }


            //return data
        }




    }

    const handleChangeRadio = async (event) => {
        event.preventDefault()
        const valor = event.target.value
        console.log(`valor ${valor}`)
        let valorPerfil = valor
        let idEntidad
        setValueRadio(valor);
        if (valor.includes('-')) {
            const indice = valor.indexOf('-')
            valorPerfil = valor.slice(0, indice)
            sessionStorage.setItem('perfil', valorPerfil)
            idEntidad = valor.slice(indice + 1)
            sessionStorage.setItem('idEntidad', idEntidad)
        }
        else
            sessionStorage.setItem('perfil', valor)
        if (!valor.includes('-')) {
            await Promise.all(
                perfiles.map(async (perfil) => {
                    if (Number(perfil.id) === Number(valorPerfil)) {
                        console.log(`Entidad del valor seleccionado ${perfil.idEntidad}`)
                        sessionStorage.setItem('idEntidad', perfil.idEntidad)
                        const resEntidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`)
                        const entidadLeida = await resEntidad.json()
                        sessionStorage.setItem('idEntidadSuperior', entidadLeida.idEntidadSuperior)
                        if (perfil.descripcion.startsWith('Titular')) {
                            setEsJefe(true)
                            sessionStorage.setItem('perfilElegido', 'jefe')
                            const resTitularPerfil = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/idTitularPerfil/${sessionStorage.getItem('perfil')}`)
                            const titular = await resTitularPerfil.json()
                            sessionStorage.setItem('idTitularPerfil', titular.idEmpleado)
                            await cargarPlan()
                            setOpenAvisos(true)
                            console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                            Object.entries(sessionStorage).forEach(([key, value]) => {
                                console.log(key)
                                console.log(value)
                            });
                            navigate(`/`, { replace: true })
                            //navigate('/false')
                            return
                        }
                        if (perfil.descripcion.startsWith ('Asistente')) {
                            setEsAsistente(true)
                            setOpenAvisos(true)
                            sessionStorage.setItem('perfilElegido', 'asistente')
                            console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                            Object.entries(sessionStorage).forEach(([key, value]) => {
                                console.log(key)
                                console.log(value)
                            });
                            navigate(`/`, { replace: true })
                            //navigate(`/seguimientoSolicitudes/division/${usuario.id}`)
                            return
                        }
                        if (perfil.descripcion.startsWith('Responsable de proyecto'))
                            sessionStorage.setItem('perfilElegido', 'investigador')
                        if (perfil.descripcion.startsWith('Administración'))
                            sessionStorage.setItem('perfilElegido', 'administracion')
                        /*if (perfil.descripcion === 'Coordinación')
                            sessionStorage.setItem('perfilElegido', 'coordinacion')*/
                        setOpenAvisos(true)
                        console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                        Object.entries(sessionStorage).forEach(([key, value]) => {
                            console.log(key)
                            console.log(value)
                        });
                        navigate(`/`, { replace: true })
                        //navigate(`/proyectosInforme/${usuario.id}/false`)
                    }
                })
            )
        }
        else {
            const resEntidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`)
            const entidadLeida = await resEntidad.json()
            sessionStorage.setItem('idEntidadSuperior', entidadLeida.idEntidadSuperior)
            perfiles.map(async (perfil) => {

                if (Number(perfil.id) === Number(valorPerfil)) {
                    if (perfil.descripcion.startsWith('Titular')) {
                        setEsJefe(true)
                        sessionStorage.setItem('perfilElegido', 'jefe')
                        const resTitularPerfil = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/idTitularPerfil/${sessionStorage.getItem('perfil')}`)
                        const titular = await resTitularPerfil.json()
                        sessionStorage.setItem('idTitularPerfil', titular.idEmpleado)
                        await cargarPlan()
                        setOpenAvisos(true)
                        console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                        Object.entries(sessionStorage).forEach(([key, value]) => {
                            console.log(key)
                            console.log(value)
                        });
                        navigate(`/`, { replace: true })
                        //navigate('/false')
                        return
                    }
                    if (perfil.descripcion === 'Asistente') {
                        setEsAsistente(true)
                        setOpenAvisos(true)
                        sessionStorage.setItem('perfilElegido', 'asistente')
                        console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                        Object.entries(sessionStorage).forEach(([key, value]) => {
                            console.log(key)
                            console.log(value)
                        });
                        navigate(`/`, { replace: true })
                        //navigate(`/seguimientoSolicitudes/division/${usuario.id}`)
                        return
                    }
                    if (perfil.descripcion.startsWith('Responsable de proyecto'))
                        sessionStorage.setItem('perfilElegido', 'investigador')
                    if (perfil.descripcion.startsWith('Administración'))
                        sessionStorage.setItem('perfilElegido', 'administracion')
                }
                setOpenAvisos(true)
                console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                Object.entries(sessionStorage).forEach(([key, value]) => {
                    console.log(key)
                    console.log(value)
                });
                navigate(`/`, { replace: true })
            }
            )
        }
        console.log(`LABEL: ${event.target.label}`)
    };
    const obtenerReglas = (decoded) => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        console.log(`perfilElegido: ${perfilElegido}`)
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (isNaN(usuario.id)) {
            setMensaje('Verifica que tus datos sean correctos, eso no parece ser una matrícula o número económico')
            setOpen(true)
            return
        }
        setLoading(true)
        //console.log(`usuario: ${JSON.stringify(usuario)}`)

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/auth/login`, {
            method: "POST",
            body: JSON.stringify(usuario),
            headers: { "Content-Type": "application/json" },
        })
        const data = await res.json()
        //colocar un mensaje para orientar al usuario, se está validando desde sequelize
        //console.log(`data=${data.token}`)

        if (data.message) {
            setOpen(true)
            setMensaje(`${data.message}`)
            setLoading(false)
            //sessionStorage.setItem('token', null)
            sessionStorage.clear()
            return
        }
        else {
            setOpen(false)
            sessionStorage.setItem('token', data.token)
        }
        const decoded = jwt_decode(data.token);
        let reglas = decoded.rules
        if (!reglas)
            reglas = obtenerReglas(decoded)

        console.log(`rules ${JSON.stringify(reglas)}`)
        setLoading(false)
        await cargarUsuario(usuario.id)
        if (reglas) {
            const idPerfil = decoded.idPerfil
            sessionStorage.setItem('perfil', idPerfil)
            sessionStorage.setItem('idEntidad', decoded.idEntidad)
            const resEntidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`)
            const entidadLeida = await resEntidad.json()
            sessionStorage.setItem('idEntidadSuperior', entidadLeida.idEntidadSuperior)
            for (let i = 0; i < reglas.length; i++) {
                // console.log(`REGLA ${i} action ${reglas[i].action} subject ${reglas[i].subject}`)
                if (reglas[i].action === 'rectoria' && reglas[i].subject === 'unidad') {
                    console.log('Es rector')
                    setEsJefe(true)
                    await cargarPlan()
                    setOpenAvisos(true)
                    console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                    Object.entries(sessionStorage).forEach(([key, value]) => {
                        console.log(key)
                        console.log(value)
                    });
                    navigate(`/`, { replace: true })
                    //navigate(`/seguimientoSolicitudes/rectoria/gestion/${usuario.id}`)
                    return
                }
                if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
                    console.log('Es jefe de depto o director')
                    setEsJefe(true)
                    const resTitularPerfil = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/idTitularPerfil/${sessionStorage.getItem('perfil')}`)
                    const titular = await resTitularPerfil.json()
                    sessionStorage.setItem('idTitularPerfil', titular.idEmpleado)
                    await cargarPlan()
                    setOpenAvisos(true)
                    console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                    Object.entries(sessionStorage).forEach(([key, value]) => {
                        console.log(key)
                        console.log(value)
                    });
                    navigate(`/`, { replace: true })
                    //navigate('/false')
                    return
                }
                if (reglas[i].action === 'asistente' && reglas[i].subject === 'division') {
                    console.log('Es asistente')
                    setEsAsistente(true)
                    setOpenAvisos(true)
                    console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
                    Object.entries(sessionStorage).forEach(([key, value]) => {
                        console.log(key)
                        console.log(value)
                    });
                    navigate(`/`, { replace: true })
                    //navigate(`/seguimientoSolicitudes/division/${usuario.id}`)
                    return
                }

            }
        }
        else {
            const reglasAsistente = decoded.rulesAsistente
            const reglasCoordinacion = decoded.rulesCoordinacion
            const reglasJefatura = decoded.rulesJefatura
            const reglasJefaturaArea = decoded.rulesJefaturaArea
            const reglasAdministracionProyecto = decoded.rulesAdministracionProyecto
            setPerfiles(decoded.perfiles)

            console.log(`reglasAsistente ${JSON.stringify(reglasAsistente)}`)
            console.log(`reglasCoordinacion ${JSON.stringify(reglasCoordinacion)}`)
            console.log(`reglasJefatura ${JSON.stringify(reglasJefatura)}`)
            console.log(`reglasJefaturaArea ${JSON.stringify(reglasJefaturaArea)}`)
            console.log(`reglasAdministracionProyecto ${JSON.stringify(reglasAdministracionProyecto)}`)
            setOpenPerfiles(true)
            return;

        }
        setOpenAvisos(true)
        console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
        Object.entries(sessionStorage).forEach(([key, value]) => {
            console.log(key)
            console.log(value)
        });
        navigate(`/`, { replace: true })
        //navigate(`/proyectosInforme/${usuario.id}/false`)
    }


    const handleChange = e => {
        const nombre = e.target.name
        const valor = e.target.value
        setUsuario({ ...usuario, [nombre]: valor })
        // console.log(`Usuario ${JSON.stringify(usuario)} nombre ${nombre} value ${valor}`)
        //copio todo lo que tenga el usuario y luego actualizo lo que se está tecleando
    }
    return (
        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            <Grid item xs={12} sm={8}>
                <Card>
                    <CardMedia
                        component="img"
                        image="/images/nadu.png"
                        alt="Nadu"
                        style={{ objectFit: 'contain' }}
                    />
                </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Card style={{ height: '100%' }}>
                    <CardHeader title='Inicio de sesión'></CardHeader>
                    <CardContent>

                        <form onSubmit={handleSubmit}>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Escriba su número económico o matrícula' name='id' onChange={handleChange} value={usuario.id} sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    {/*<TextField label='Escriba su password' name='password' type="password" onChange={handleChange} value={usuario.password} sx={{ width: '100%' }} />*/}
                                    <FormControl sx={{ width: '100%' }} variant="outlined">
                                        <InputLabel htmlFor="password">Escriba su password</InputLabel>
                                        <OutlinedInput id='password'
                                            name='password' onChange={handleChange} value={usuario.password}
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={togglePassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Escriba su password"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={!usuario.id || !usuario.password || loading}>
                                        Iniciar sesión
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Link href="/auth/restablecerPassword" style={{ marginTop: 20 }}>Restablecer password</Link>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Link href="/auth/registroAlumno" style={{ marginTop: 20 }}>Soy alumno de nuevo ingreso</Link>
                                </Grid>
                            </Grid>
                        </form>

                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity='error'
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                        <Typography component='span' style={{ color: 'rgb(156, 39, 176)', fontSize: 'inherit' }}><br />Importante:</Typography><Typography component='span' style={{ color: 'black', fontSize: 'inherit' }}> Si tienes algún problema con la aplicación por favor envía una captura de pantalla y una breve descripción del problema al correo </Typography><Typography component='span' style={{ color: 'rgb(156, 39, 176)', fontSize: 'inherit' }}>fmedina@correo.ler.uam.mx<br />&nbsp;</Typography>
                    </CardContent>
                </Card>

            </Grid>
            <Dialog open={openPerfiles} fullWidth={true}
                maxWidth='sm' >

                <DialogContent style={{ backgroundColor: '#FFFEED' }}>
                    <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group" style={{ fontSize: '150%', fontWeight: 'bold', color: 'GrayText' }}>Elija uno de sus perfiles para ingresar</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={valueRadio}
                            onChange={handleChangeRadio}
                        >
                            {
                                perfiles.map((perfil) => (
                                    <FormControlLabel value={Number(perfil.id) === Number(570) ? `${perfil.id}-${perfil.idEntidad}` : perfil.id} key={Number(perfil.id) === Number(570) ? `${perfil.id}-${perfil.idEntidad}` : perfil.id} control={<Radio />} label={perfil.descripcion} />
                                ))
                            }
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ backgroundColor: '#FFFEED' }}>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}